import * as firebase from "firebase";

export const fireAnalytics = (eventName, eventParams) => {
  
  firebase.analytics().logEvent(eventName, eventParams);
};

